import { render, staticRenderFns } from "./InfoAboutObject.vue?vue&type=template&id=0ca58960&scoped=true&"
import script from "./InfoAboutObject.vue?vue&type=script&lang=js&"
export * from "./InfoAboutObject.vue?vue&type=script&lang=js&"
import style0 from "./InfoAboutObject.vue?vue&type=style&index=0&id=0ca58960&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca58960",
  null
  
)

export default component.exports